const portMap: { [key: string]: string } = {
  en: '4201',
  da: '4203',
  de: '4204',
};

export const localUrlSwitcher = (code: string) => {
  const targetPort = portMap[code];

  if (targetPort) {
    window.location.href = window.location.href.replace(/:\d+/, `:${targetPort}`);
  } else {
    console.error(`No local port mapping found for language code: '${code}'.`);
  }
};
